<template>
  <div>
    <modal-historial-nuevo
      @error="toastError($event)"
      @saveNuevoHistoria="saveNewHistorial($event)"
      @changeName="observacionHistorialNuevo = $event"
      :showLoading="showLoadingNuevoHistorial"
      :nombreSlots="observacionHistorialNuevo"
    ></modal-historial-nuevo>
    <modal-generar-confirmacion
      :list-partidos-enviar="listPartidosEnviar"
      :historialSeleccionado="historialSeleccionado.value"
      :list-slots="listSlots"
      @errorGuardarHorarios="errorGuardarHorarios"
      @guardadoHorarios="horariosGuardados"
    ></modal-generar-confirmacion>
    <b-card no-body class="p-1">
      <b-row>
        <b-col md="3">
          <v-select
            :options="listCampeonatos"
            @input="changeCampeonato"
            placeholder="Selecciona Campeonato"
            :clearable="false"
            v-model="campeonatoSeleccionado"
          />
        </b-col>
        <b-col md="3">
          <v-select
            :options="listHistoriales"
            @input="changeHistorial"
            placeholder="Selecciona Historial"
            :clearable="false"
            v-model="historialSeleccionado"
          />
        </b-col>
        <b-col md="3">
          <b-button
            v-if="
              USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
            "
            v-b-tooltip.hover.v-primary
            title="Crear Nuevo Historial"
            variant="flat-primary"
            class="btn-icon"
            @click="openModalHistorialNuevo"
          >
            <feather-icon size="22" icon="PlusIcon" />
          </b-button>
        </b-col>
        <b-col md="3">
          <v-select
            v-if="historialSeleccionado.value !== null"
            :options="listConfigSlotsAsignaciones"
            @input="getInfoFechasEtapas"
            placeholder="Seleccione Slots"
            :clearable="false"
            v-model="slotSeleccionado"
          />
        </b-col>
        <span v-if="historialSeleccionado.value !== null" class="observacion">{{
          historialSeleccionado.observacion
        }}</span>
        <b-col md="12"></b-col>
      </b-row>
    </b-card>
    <b-overlay :show="showContenedor" rounded="sm">
      <b-card v-if="listCategorias.length !== 0" class="text-center">
        <b-row v-for="item in listCategorias" :key="item.id">
          <row-asignacion
            :item="item"
            :permitirSeleccionar="permitirSeleccionar"
            @selecciono="agregarQuitarPartidos($event, 'put')"
            @deselecciono="agregarQuitarPartidos($event, 'delete')"
          ></row-asignacion>
        </b-row>
        <b-row>
          <b-col
            md="12"
            style="text-align: center;font-size: 23px;color: firebrick;"
          >
            {{ listPartidosEnviar.length }} / {{ slotsDisponibles }}
          </b-col>
        </b-row>
        <b-row>
          <p class="glosario">Total Slots: {{ totalSlots }}</p>
          <p class="glosario" style="color:firebrick">
            Slots Disponibles: {{ slotsDisponibles }}
          </p>
          <p class="glosario">Slots Bloqueados: {{ slotsBloqueados }}</p>
          <p class="glosario">
            * Para asignar un partido a un slot, simplemente haga click sobre el
            partido. Para quitarlo, hacer click derecho sobre el mismo partido.
          </p></b-row
        >
        <b-button
          v-if="
            (USER().rol === ROLES.SUPER ||
              USER().rol === ROLES.ADMIN ||
              USER().rol === ROLES.TECNICA) &&
              listPartidosEnviar.length > 0
          "
          v-b-tooltip.hover.v-primary
          title=""
          variant="primary"
          class="btn-icon"
          @click="guardarHorarios"
        >
          GENERAR HORARIOS
        </b-button>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import {
  //   BTabs,
  //   BTab,
  BCard,
  BRow,
  BCol,
  BButton,
  VBTooltip,
  BOverlay,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  onMounted,
  ref,
  watch,
  computed,
  // xxx,
  // xxxx,
  // xxxx,
  // xx,
} from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  // DISCIPLINAS,
  // ACTION_INSERT
} from '../../utils/variables'
import RowAsignacion from './FilaAsignacion.vue'
import ModalGenerarConfirmacion from './ModalGenerarConfirmacion.vue'
import ModalHistorialNuevo from './ModalHistorialNuevo.vue'

export default {
  components: {
    // BTabs,
    // BTab,
    BCard,
    BRow,
    BCol,
    vSelect,
    RowAsignacion,
    ModalGenerarConfirmacion,
    BButton,
    BOverlay,
    ModalHistorialNuevo,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    listConfigSlotsAsignaciones: Array,
  },
  setup() {
    const listCategorias = ref([])
    const listSlots = ref([])
    const listPartidosEnviar = ref([])
    const listHistoriales = ref([])
    const showContenedor = ref(false)
    const observacionHistorialNuevo = ref('')
    const showLoadingNuevoHistorial = ref(false)
    const historialSeleccionado = ref({
      label: 'Seleccione Historial',
      value: null,
    })
    const slotSeleccionado = ref({
      label: 'Seleccione slots',
      value: null,
    })
    const etapaSeleccionado = ref({
      label: 'Etapa',
      value: null,
    })
    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })
    const listCampeonatos = ref([])
    const totalSlots = ref(0)
    const slotsDisponibles = ref(0)
    const slotsBloqueados = ref(0)
    const permitirSeleccionar = computed(
      () => listPartidosEnviar.value.length < slotsDisponibles.value,
    )
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    const { postApi, getApi } = apiCall()

    function agregarQuitarPartidos(item, accion) {
      if (accion === 'put') {
        listPartidosEnviar.value.push(item)
      } else {
        const found = listPartidosEnviar.value.findIndex(
          // eslint-disable-next-line
          element => element.id_partido === item.id_partido,
        )
        // console.log(found)
        listPartidosEnviar.value.splice(found, 1)
      }
      // console.log(listPartidosEnviar.value)
    }

    function errorGuardarHorarios() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Error al guardar horarios',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    function resetData() {
      listCategorias.value = []
      listSlots.value = []
      listPartidosEnviar.value = []
      totalSlots.value = 0
      slotsDisponibles.value = 0
      slotsBloqueados.value = 0
      showContenedor.value = false
    }
    async function getHistoriales() {
      listHistoriales.value = []
      historialSeleccionado.value = {
        label: 'Seleccione Historial',
        value: null,
      }
      slotSeleccionado.value = {
        label: 'Seleccione slots',
        value: null,
      }
      resetData()
      // isCreando.value = true
      // showLoadingModal.value = true
      const path = `ApiConfiguration/getHistorialesXCampeonato/${campeonatoSeleccionado.value.value}`
      const data = await getApi(URL, path)
      listHistoriales.value = data
      // showLoadingModal.value = false
    }
    async function saveNewHistorial() {
      showLoadingNuevoHistorial.value = true
      const data = {
        observacion: observacionHistorialNuevo.value,
        id_campeonato: campeonatoSeleccionado.value.value,
        id_user: USER().id_usuario,
      }
      // console.log(data)
      const path = 'ApiConfiguration/insertNuevoHistorial'
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Historial creado con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
        getHistoriales()
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Error al crear historial',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      }
      store.commit('someVariables/UPDATE_SHOW_NUEVO_HISTORIAL', false)
      observacionHistorialNuevo.value = ''
      showLoadingNuevoHistorial.value = false
    }
    function guardarHorarios() {
      // console.log('guardar horarios')
      store.commit(
        'someVariables/UPDATE_SHOW_GENERAR_CONFIRMACION',
        // eslint-disable-next-line
        true,
      )
    }

    async function getInfoFechasEtapas(item) {
      // showLoading.value = true
      showContenedor.value = true
      // console.log(slotSeleccionado.value)
      listCategorias.value = []
      listSlots.value = []
      listPartidosEnviar.value = []
      const data = {
        categorias: item.categorias,
        id_campeonato: campeonatoSeleccionado.value.value,
        rol: USER().rol,
        id_fixture_slot_config: slotSeleccionado.value.value,
      }
      // console.log(data)
      const path = 'ApiConfiguration/getCategoriasEtapasFechasSlot'
      const response = await postApi(URL, path, data)
      listCategorias.value = response.categorias
      listSlots.value = response.slots
      totalSlots.value = response.total_slots
      slotsDisponibles.value = response.slots_disponibles
      slotsBloqueados.value = response.slots_bloqueados
      showContenedor.value = false
      // console.log(response)
    }

    function openModalHistorialNuevo() {
      store.commit('someVariables/UPDATE_SHOW_NUEVO_HISTORIAL', true)
    }
    function horariosGuardados() {
      listPartidosEnviar.value = []
      // slotSeleccionado.value = {
      //   label: 'Seleccione slots',
      //   value: null,
      // }
      getInfoFechasEtapas(slotSeleccionado.value)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'HORARIOS GENERADOS con éxito, REVISE EL HISTORIAL',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }
    function changeCampeonato() {
      getHistoriales()
    }
    function changeHistorial() {
      slotSeleccionado.value = {
        label: 'Seleccione slots',
        value: null,
      }
      resetData()
    }
    onMounted(() => {
      // getP()
      // getListCategorias(
      //   // eslint-disable-next-line
      //   store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      // )
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's',
      )
      campeonatoSeleccionado.value = campActivo
      getHistoriales()
    })
    function toastError(mensaje) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: mensaje,
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    watch(cambioTorneo, () => {
      campeonatoSeleccionado.value = null
      listCampeonatos.value = []
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
    })
    return {
      slotSeleccionado,
      listCampeonatos,
      changeCampeonato,
      campeonatoSeleccionado,
      getInfoFechasEtapas,
      listCategorias,
      etapaSeleccionado,
      ROLES,
      USER,
      agregarQuitarPartidos,
      guardarHorarios,
      slotsBloqueados,
      slotsDisponibles,
      totalSlots,
      listPartidosEnviar,
      permitirSeleccionar,
      showContenedor,
      horariosGuardados,
      errorGuardarHorarios,
      listSlots,
      listHistoriales,
      historialSeleccionado,
      openModalHistorialNuevo,
      observacionHistorialNuevo,
      showLoadingNuevoHistorial,
      saveNewHistorial,
      toastError,
      changeHistorial,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.glosario {
  margin-left: 4px;
  margin-right: 10px;
  background: #efefef;
  color: gray;
  font-size: 11px;
  padding: 4px;
  border-radius: 4px;
}
.observacion {
  padding: 4px;
  background: gold;
  margin-left: 15px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 11px;
}
</style>
